import { createSlice } from '@reduxjs/toolkit';

const yojnaIdManagementSlice = createSlice({
    name: 'yojnaId',
    initialState: {
        yojnaId: null,
    },
    reducers: {
        setYojnaId: (state, action) => {
            state.yojnaId = action.payload;
        },
    },
});

export const { setYojnaId } = yojnaIdManagementSlice.actions;

export default yojnaIdManagementSlice.reducer;